var React = require('react');

function UserPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.25 9.75a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0zM15 0C9.616 0 5.25 4.366 5.25 9.75S9.616 19.5 15 19.5s9.75-4.366 9.75-9.75S20.384 0 15 0zM3 36.5c.002-6.627 5.376-11.998 12.003-11.996 4.006.002 7.747 2 9.972 5.33a1.5 1.5 0 002.494-1.668 14.999 14.999 0 00-12.464-6.662C6.72 21.502.001 28.215 0 36.5a1.5 1.5 0 003 0zM34.5 24a1.5 1.5 0 00-1.5 1.5V38h12V25.5a1.5 1.5 0 00-1.5-1.5h-9zM45 41H33v2.5a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5V41zM30 25.5c0-2.484 2.016-4.5 4.5-4.5h9c2.484 0 4.5 2.016 4.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5h-9a4.501 4.501 0 01-4.5-4.5v-18z"}));
}

UserPhone.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = UserPhone;

UserPhone.default = UserPhone;
